import React, { useState } from 'react';

const CapWidget = ({ 
  onVerify, 
  onError, 
  theme = 'light',
  size = 'normal',
  className = '',
  siteKey = 'salesign-demo'
}) => {
  const [isVerified, setIsVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleVerify = () => {
    setIsLoading(true);
    
    // Simulate a brief loading period for better UX
    setTimeout(() => {
      setIsVerified(true);
      setIsLoading(false);
      // Generate a simple token
      const token = btoa(JSON.stringify({
        timestamp: Date.now(),
        siteKey: siteKey,
        verified: true
      }));
      onVerify?.(token);
    }, 1000);
  };

  return (
    <div className={`cap-widget-container ${className}`}>
      <div 
        className={`cap-widget ${isVerified ? 'verified' : ''}`}
        style={{
          minHeight: '78px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {!isVerified ? (
          <div className="flex flex-col items-center space-y-3 p-4">
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="security-check"
                onChange={(e) => {
                  if (e.target.checked && !isLoading) {
                    handleVerify();
                  }
                }}
                disabled={isLoading}
                className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 disabled:opacity-50"
              />
              <label htmlFor="security-check" className="text-sm text-gray-700 cursor-pointer">
                I'm not a robot
              </label>
            </div>
            
            {isLoading && (
              <div className="flex items-center space-x-2">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                <span className="text-xs text-gray-600">Verifying...</span>
              </div>
            )}
            
            <div className="text-xs text-gray-500 text-center">
              <div className="flex items-center justify-center space-x-1">
                <span>🔒</span>
                <span>Security verification</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex items-center space-x-2 p-4 text-green-600">
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            <span className="text-sm font-medium">Verified</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CapWidget;